module.exports = __webpack_public_path__ + "img/svg/step6.52a2011140009bad79a7d97e875a065b.svg";